import React, { useState } from 'react';
import { ButtonProps, Grid, TextFieldProps } from '@material-ui/core';
import { PrimaryButton } from 'library';
import Input from 'reusableComponents/input';

const ReferralMethod = ({
    buttonText,
    action,
    buttonProps,
    inputProps,
    title,
    loading,
}: {
    buttonText: string;
    action: (e: any) => void;
    buttonProps?: ButtonProps;
    inputProps?: TextFieldProps;
    title?: React.ReactNode;
    loading?: boolean;
}) => {
    const [value, setValue] = useState();

    const onValueChanged = (event: any) => {
        setValue(event.target.value);
    };

    return (
        <Grid container justify="space-between" alignItems="flex-end" style={{ padding: 10, marginBottom: 30 }}>
            <Grid item xs={12} md={8}>
                {title}
                <Input
                    fullWidth
                    style={{ marginBottom: 0 }}
                    value={value}
                    onChange={onValueChanged}
                    multiline
                    {...inputProps}
                />
            </Grid>
            <Grid item xs={6} md={3} style={{ marginTop: 10 }}>
                <PrimaryButton loading={loading} disabled={loading} onClick={action} {...buttonProps}>
                    {buttonText}
                </PrimaryButton>
            </Grid>
        </Grid>
    );
};

export default ReferralMethod;
